import {AnyFieldApi} from '@tanstack/form-core';
import {useEvFormInputClass} from './useEvFormInputClass';
import {NumberHelper} from '../../helper/number-helper';
import {clsx} from 'clsx';

interface Props {
  id?: string;
  field: AnyFieldApi;
  title?: string;
  formStyle?: 'sm' | null | undefined;
  className?: string;
  disabled?: boolean | null | undefined;
  numberType?: 'decimal' | 'int' | null | undefined;
  decimals?: number | null | undefined;
  nullable?: boolean | null | undefined;
  numberFormatFunction?: (number: number | string | null | undefined, decimals?: number) => string;
}

export function EvNumberInputField(props: Props) {
  const decimals = props.decimals ?? 0;
  const parseFunction = (
    props.numberType === 'decimal' ? NumberHelper.saveParseFloat : NumberHelper.saveParseInteger
  );
  const formatFunction = (v: string | number | null | undefined) => {
    const parsed = parseFunction(v);
    if (props.nullable === true && parsed == null) {
      return '';
    }

    return (props.numberFormatFunction ?? NumberHelper.formatDe)(
      NumberHelper.roundDecimal(parsed ?? 0, decimals), decimals);
  };
  const value = props.field.state.meta.isPristine ?
    formatFunction(props.field.state.value) :
    typeof props.field.state.value === 'string' ?
      props.field.state.value :
      formatFunction(props.field.state.value);
  const className = useEvFormInputClass(props);

  return <input id={props.id ?? props.field.name}
                title={props.title}
                name={props.field.name}
                value={value}
                disabled={props.disabled ?? false}
                onBlur={(e) => {
                  props.field.handleChange(parseFunction(e.target.value) ?? (props.nullable === true ? '' : 0));
                }}
                onChange={(e) => props.field.handleChange(e.target.value)}
                className={clsx(className, props.className)}/>;
}
